module.exports = __webpack_public_path__ + "static/media/icon-velocidade.12226335.svg";